import { useMutation, useQueryClient } from '@tanstack/react-query';
import { mainApi } from '@/lib/api';
import { QUERY_KEYS, StoreType } from '@/lib/constants';
import { stanNotify } from '@/lib/stanNotify';

export function useDeleteFunnelPage(storeId: number) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (pageId: number) => {
            await mainApi.delete(`v1/stores/${storeId}/pages/${pageId}`);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.FUNNELS, 'detail', storeId] });
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.STORE_DATA, StoreType.FUNNEL] });
            stanNotify({ type: 'success', title: 'Page deleted!', duration: 2000 });
        },
        onError: () => {
            stanNotify({
                type: 'error',
                title: 'Oops!',
                text: 'Failed to delete page. Please try again.',
                duration: 2000,
            });
        },
    });
}
